import React, { useEffect } from "react";
import AuthSlider from "./AuthSlider.jsx";
import LoadingModal from "./LoadingModal.jsx";
import { useSelector } from "react-redux";
import { useTurnstileState } from "./TurnstileWidget.jsx";
import LoginDiagnostics from "./LoginDiagnostics.jsx";

const LayoutAuth = ({ children }) => {
  const { isLoading } = useSelector((state) => state.appsetting);
  const { waiting: verifying } = useTurnstileState();

  // Set page title for auth pages
  useEffect(() => {
    document.title = "Tax filing - Prime Meridian";
  }, []);

  return (
    <div className="flex flex-col md:flex-row p-0 md:p-0 min-h-screen auth-layout overflow-y-auto">
      {/* Mobile header */}
      <div className="logo-mobile py-4 px-4">
        <p className="font-lora font-semibold text-xl text-black">
        Prime Meridian
        <br />File your 2025 tax return for free.
      </p>
      </div>
      <AuthSlider />
      <div className="w-full md:w-[70%] flex flex-col items-center md:min-h-screen auth-form px-4 md:px-0 pb-8 md:pb-0">
        <div className="w-[50%] mt-[5%] hidden md:block">
          <p className="font-lora font-semibold text-2xl text-black logo-pc">
            Prime Meridian
            <br />File your 2025 tax return for free.
          </p>
        </div>
        {children}
        <LoginDiagnostics />
        <LoadingModal open={isLoading && !verifying} />
      </div>
    </div>
  );
};
export default LayoutAuth;
